<template>
  <Layout>
    <div class="row">
      <div class="outBox">
        <div class="box-1">
          <div class="chat-messages">
            <div id="msglist">
              <div
                v-for="(message, index) in chatList"
                :key="index"
                :id="'msg-' + message.id"
              >
                <div
                  v-if="message.isSelf"
                  class="chat-right-box flex-depart-right-top"
                >
                  <div class="chat-content chat-content-right">
                    <div class="user-name n-right"></div>
                    <div class="content-box-comm content-box-right">
                      <div>
                        {{ message.content }}
                      </div>
                    </div>
                  </div>
                  <div class="tx">
                    <img :src="myTx" />
                  </div>
                </div>
                <!--left-->
                <div
                  v-if="!message.isSelf"
                  class="chat-left-box flex-depart-top"
                >
                  <div class="tx tx-left">
                    <img
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/chat-AI.png"
                      alt=""
                    />
                  </div>
                  <div class="chat-content">
                    <div class="user-name n-left">智能助手</div>
                    <div class="content-box-comm content-box-left">
                      <div class="content-txt">
                        {{ message.content }}
                      </div>
                      <el-divider></el-divider>
                      <!--最后一步的提示-->
                      <div
                        v-if="showConfirmBtnIndex === index && showConfirmBtn"
                        class="flex-depart-left-center c-btns"
                      >
                        <div
                          class="c-btns-item flex-depart-center"
                          @click="CopyText"
                        >
                          <img :src="fzImgSrc" />
                          <span>复制文字</span>
                        </div>
                        <div
                          class="c-btns-item flex-depart-center"
                          @click="RegenerateMessage"
                        >
                          <img :src="restartImgSrc" />
                          <span>重新生成</span>
                        </div>
                      </div>
                      <div
                        v-if="showConfirmBtnIndex === index && showConfirmBtn"
                        class="build-btn"
                        @click="createConfirmMessage"
                      >
                        立即生成
                      </div>

                      <!--第一步的提示-->
                      <div class="eachOne-box" v-if="index === 0">
                        <div
                          class="each-item flex-depart-left-center"
                          v-for="(title, index1) in createTextTemplate"
                          :key="index1"
                        >
                          <span class="aPoint">●</span>
                          <div
                            class="point-after flex-depart-left-center"
                            @click="addQuickMessage(title)"
                          >
                            <div class="pa-txt">{{ title }}</div>
                            <!--                                                    <u-icon name="arrow-right" color="#3C78FF" size="12"></u-icon>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 输入区域 -->
        <div class="input-container">
          <div class="input-wrapper">
            <el-input v-model="inputText" placeholder="请输入内容"></el-input>
            <el-button
              type="primary"
              @click="handleSend"
              style="background-color: #1877ff"
              >发送</el-button
            >
          </div>
        </div>

        <div class="cancel-box" v-if="recording">
          <div
            class="animation-box"
            :class="{ 'bg-blue': !isCanceling, 'bg-red': isCanceling }"
          >
            <div class="voice-wave-animation">
              <div class="wave-bar" v-for="i in 28" :key="i"></div>
            </div>
            <div
              class="sanjiao"
              :class="{ 'bg-blue': !isCanceling, 'bg-red': isCanceling }"
            ></div>
          </div>
          <img
            class="cancel-btn2"
            src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/close-yuyin.svg"
          />
          <dov class="qxBtn">取消</dov>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import { imageUrl, SOCKET_AI_URL } from "@/utils/config/commonUrl.js";
import WebSocketManager from "../../../../utils/WebSocketManager";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "AI发布接龙",
    meta: [{ name: "description", content: appConfig.description }],
  },
  name: "AIPublishJieLong",
  components: { Layout },
  data() {
    return {
      userInput: "",
      messages: [],
      socket: null,
      heartbeatTimer: null,
      wsUrl: "wss://jlsockettest.xshangyun.com/chatAi", // ✅ 你的 WebSocket 地址
      isActive: true, // ✅ 用于控制是否自动重连

      fzImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/chat-fuzhi.svg",
      restartImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/chat-chongxin.svg",
      chatList: [], // 聊天记录列表
      inputText: "", // 输入框文本
      isVoice: false, // 是否为语音输入模式
      socketTask: null, // WebSocket 实例
      serverUrl: SOCKET_AI_URL + "chatAi",
      currentMessage: "", // 当前累积的消息
      finalMessage: "", // 新增：当前完整的消息
      streamingMessage: "", // 新增：用于流式显示的当前消息
      lastMessageIndex: -1, // 新增：最后一条消息的索引
      showConfirmBtn: false, // 新增：控制确认按钮显示
      showConfirmBtnIndex: 0, // 新增：控制确认按钮显示 的索引
      isCreating: false, // 新增：创建中状态
      createTextTemplate: [
        "生成一个每日英语阅读打卡",
        "生成一个签售会报名接龙",
        "生成一个签到打卡",
      ], //默认进入时提示的文案
      isFirstConnect: true, // 新增：是否是首次连接的标志位
      retryTimer: null, // 新增：重试计时器
      recording: false,
      recorderManager: null,
      isConnecting: false, // 新增：标记是否正在连接中
      myTx: "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/chat-user.png",
      isCanceling: false, // 新增：是否正在取消录音
      cancelBtnRect: null, // 新增：取消按钮的位置信息
      // 滚动容器
      scrollView: {
        refresherTriggered: false,
        intoView: "",
        safeAreaHeight: 0,
      },
      isFirstLoad: true, // 是否首次加载
      isScrolling: false, // 是否正在滚动
      isMessageComplete: false, // 添加消息完成状态标志
      mustScrollTop: 0,
      scrollTimer: null, // 新增：滚动轮询定时器
      lastMessageLength: 0, // 新增：记录上一条消息的长度
      isAutoScroll: true, // 是否自动滚动
      lastScrollTop: 0, // 上次滚动位置
      isManualScroll: false, // 是否手动滚动
      firstSee: true,
      touchStartTime: 0, // 新增：触摸开始时间
      hasLongPressed: false, // 是否已经长按
      loading: {},
    };
  },
  beforeDestroy() {
    this.isActive = false; // ✅ 阻止后续的自动重连
    // 可选：离开页面时关闭连接
    if (this.socket) {
      WebSocketManager.closeConnection(this.serverUrl);
      console.log("🔌 WebSocket 已关闭");
      this.socket = null;
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  },
  created() {
    // 初始化WebSocket连接
    this.initWebSocket();
    this.myTx = localStorage.getItem("myProfilePhoto");
  },
  methods: {
    initWebSocket() {
      // 获取现有连接
      const existingSocket = WebSocketManager.getExistingConnection(
        this.serverUrl
      );
      if (existingSocket) {
        this.socketTask = existingSocket;
        const socketTaskList =
          JSON.parse(localStorage.getItem("socketTaskList")) || [];
        const updatedList = socketTaskList.map((conn) => {
          if (conn.url === this.serverUrl) {
            return { ...conn, timestamp: Date.now() };
          }
          return conn;
        });
        localStorage.setItem("socketTaskList", JSON.stringify(updatedList));

        if (this.isFirstConnect) {
          this.addMessage(
            "你好，我是智能AI助手小V，您可以输入文字告诉我您对报名、接龙、打卡、信息收集的需求，我为您生成适合的接龙内容。有什么可以帮我吗？",
            false
          );
          this.isFirstConnect = false;
        }
        this.isConnecting = false;
      } else {
        this.loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // 如果没有现有连接，创建新连接
        this.connectWebSocket();
      }
    },
    connectWebSocket() {
      // 创建新的WebSocket连接
      this.socketTask = new WebSocket(this.serverUrl);

      this.socketTask.onopen = () => {
        console.log("WebSocket连接已建立");
        this.loading.close();
        this.isConnecting = false;
        if (this.isFirstConnect) {
          this.addMessage(
            "你好，我是智能AI助手小V，您可以输入文字告诉我您对报名、接龙、打卡、信息收集的需求，我为您生成适合的接龙内容。有什么可以帮我吗？",
            false
          );
          this.isFirstConnect = false;
        }
      };

      this.socketTask.onmessage = (event) => {
        // 直接使用接收到的消息
        this.currentMessage += event.data;
        const shouldAutoScroll = this.isFirstLoad || !this.isScrolling;

        if (event.data.includes("[complete]")) {
          this.isMessageComplete = true;
          this.finalMessage = this.currentMessage.replace("[complete]", "");
          this.updateLastMessage(this.finalMessage);
          this.checkNeedCreateActivity(this.finalMessage);

          this.$nextTick(() => {
            this.scrollToBottom();
            this.isFirstLoad = false;
            this.currentMessage = "";
            this.streamingMessage = "";
            this.lastMessageIndex = -1;
            this.isMessageComplete = false;
          });
        } else {
          if (this.lastMessageIndex === -1) {
            this.streamingMessage = event.data;
            this.addMessage(this.streamingMessage, false);
            this.lastMessageIndex = this.chatList.length - 1;
          } else {
            this.streamingMessage += event.data;
            this.updateLastMessage(this.streamingMessage);
          }

          if (shouldAutoScroll) {
            this.startScrollPolling();
          }
        }
      };

      this.socketTask.onerror = (error) => {
        console.error("WebSocket错误:", error);
        this.isConnecting = false;
      };

      this.socketTask.onclose = () => {
        console.log("WebSocket连接已关闭");
        this.isConnecting = false;
      };

      // 保存连接信息
      const socketTaskList =
        JSON.parse(localStorage.getItem("socketTaskList")) || [];
      const newConnection = {
        url: this.serverUrl,
        timestamp: Date.now(),
      };
      const updatedList = [...socketTaskList, newConnection];
      localStorage.setItem("socketTaskList", JSON.stringify(updatedList));
    },
    calculateAudioWidth(duration) {
      const minWidth = 120;
      const maxWidth = 280;
      const seconds = parseInt(duration) || 0;

      if (seconds <= 1) return minWidth + "px";
      if (seconds >= 10) return maxWidth + "px";

      const width = minWidth + ((maxWidth - minWidth) / 9) * (seconds - 1);
      return Math.round(width) + "px";
    },
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      const scrollHeight = e.target.scrollHeight;
      const clientHeight = e.target.clientHeight;

      const isBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 10;

      // 判断是否是手动向上滚动
      if (scrollTop < this.lastScrollTop) {
        this.isManualScroll = true;
        this.isAutoScroll = false;
      } else if (scrollTop > this.lastScrollTop) {
        if (isBottom) {
          const scrollDistance = scrollTop - this.lastScrollTop;
          if (scrollDistance > 50) {
            this.isManualScroll = false;
            this.isAutoScroll = true;
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        }
      }

      this.lastScrollTop = scrollTop;
      this.isScrolling = !isBottom;
    },
    checkSocketLimit() {
      return new Promise((resolve) => {
        if (navigator.onLine) {
          try {
            const socketTaskList =
              JSON.parse(localStorage.getItem("socketTaskList")) || [];
            const now = Date.now();
            const validConnections = socketTaskList.filter((conn) => {
              return now - conn.timestamp < 30 * 60 * 1000;
            });

            localStorage.setItem(
              "socketTaskList",
              JSON.stringify(validConnections)
            );

            if (validConnections.length >= 5) {
              validConnections.sort((a, b) => a.timestamp - b.timestamp);
              const oldestConn = validConnections.shift();
              if (oldestConn) {
                WebSocketManager.closeConnection(oldestConn.url);
                localStorage.setItem(
                  "socketTaskList",
                  JSON.stringify(validConnections)
                );
              }
            }
            resolve(true);
          } catch (error) {
            console.error("检查WebSocket连接限制时出错:", error);
            resolve(false);
          }
        } else {
          console.error("网络未连接");
          resolve(false);
        }
      });
    },
    handleSend() {
      const message = this.inputText.trim();
      if (message && this.socketTask) {
        // 发送消息到服务器
        try {
          this.socketTask.send(message);
          console.log("消息发送成功1111111111111");
          // 先添加消息到列表
          this.addMessage(message, true);
          // 清空输入框
          this.inputText = "";
          // 重置滚动状态
          this.isManualScroll = false;
          this.isAutoScroll = true;
          // this.socketTask.send({
          //     data: message,
          //     success: () => {
          //         console.log('消息发送成功1111111111111');
          //         // 先添加消息到列表
          //         this.addMessage(message, true);
          //         // 清空输入框
          //         this.inputText = '';
          //         // 重置滚动状态
          //         this.isManualScroll = false;
          //         this.isAutoScroll = true;
          //     },
          //     fail: (error) => {
          //         console.error('消息发送失败:', error);
          //         // 发送失败时可以从列表中移除该消息
          //         this.chatList.pop();
          //     }
          // });
        } catch (error) {
          console.error("发送消息时出错:", error);
          // 发送出错时可以从列表中移除该消息
          this.chatList.pop();
        }

        // 确保视图更新
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    handleRecordTouchStart(e) {
      this.touchStartTime = Date.now();
      this.touchStarted = true;
      this.hasLongPress = false;
      this.longPressTimer = setTimeout(() => {
        this.hasLongPress = true;
        this.startRecord();
      }, 350);
    },
    handleRecordTouchEnd(e) {
      clearTimeout(this.longPressTimer);
      const duration = Date.now() - this.touchStartTime;
      this.touchStarted = false;
      if (!this.hasLongPress) {
        alert("录音时长太短");
      } else {
        this.endRecord();
      }
    },
    startRecord() {
      this.touchStartY = 0;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            this.recording = true;
            const mediaRecorder = new MediaRecorder(stream);
            const audioChunks = [];

            mediaRecorder.ondataavailable = (e) => {
              audioChunks.push(e.data);
            };

            mediaRecorder.onstop = () => {
              const audioBlob = new Blob(audioChunks, { type: "audio/mp3" });
            };

            mediaRecorder.start();
            this.recorderManager = mediaRecorder;
          })
          .catch(() => {
            alert("请授权录音权限");
          });
      }
    },
    endRecord() {
      if (!this.recording) return;
      if (this.recorderManager) {
        this.recorderManager.stop();
        this.recording = false;
      }
    },
    cancelRecord() {
      if (this.recording) {
        this.isCanceling = true;
        if (this.recorderManager) {
          this.recorderManager.stop();
          this.recording = false;
        }
      }
    },
    handleTouchMove(e) {
      if (!this.recording) return;

      const touchY = e.touches[0].clientY;
      if (!this.touchStartY) {
        this.touchStartY = touchY;
      }

      const moveDistance = this.touchStartY - touchY;
      this.isCanceling = moveDistance > 50;
    },
    addMessage(content, isSelf, type = "text", audioUrl = "") {
      let audioDuration = 0;
      if (type === "audio") {
        audioDuration = parseInt(content) || 0;
      }

      // 使用 Vue.set 确保响应式更新
      this.$set(this.chatList, this.chatList.length, {
        id: `msg-${Date.now()}`,
        content,
        isSelf,
        time: this.getCurrentTime(),
        type: type,
        audioUrl: audioUrl,
        isPlay: false,
        audioDuration,
      });

      // 强制更新视图
      this.$forceUpdate();

      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    playAudio(audioUrl, index) {
      if (!audioUrl) return;
      const audio = new Audio(audioUrl);

      audio.onplay = () => {
        this.$set(this.chatList[index], "isPlay", true);
      };

      audio.onended = () => {
        this.$set(this.chatList[index], "isPlay", false);
      };

      audio.onerror = () => {
        this.$set(this.chatList[index], "isPlay", false);
        alert("音频播放失败");
      };

      audio.play();
    },

    scrollToBottom() {
      if (this.firstSee) {
        this.firstSee = false;
        return false;
      }

      // 如果用户手动滚动了，则不自动滚动
      if (this.isManualScroll) return;

      this.$nextTick(() => {
        const msgList = document.getElementById("msglist");
        if (msgList) {
          // 计算滚动距离
          const scrollTop = msgList.scrollTop;
          const scrollHeight = msgList.scrollHeight;
          const clientHeight = msgList.clientHeight;
          const scrollDistance = scrollHeight - scrollTop - clientHeight;

          // 如果滚动距离超过200px，则不自动滚动
          if (scrollDistance > 200) {
            this.isManualScroll = true;
            return;
          }

          // 确保在DOM更新后执行滚动
          setTimeout(() => {
            msgList.scrollTop = scrollHeight;

            // 如果第一次滚动失败，尝试再次滚动
            if (msgList.scrollTop === 0) {
              setTimeout(() => {
                msgList.scrollTop = scrollHeight;
              }, 100);
            }
          }, 0);

          const lastMessageId = this.chatList[this.chatList.length - 1]?.id;
          if (lastMessageId) {
            this.scrollView.intoView = `msg-${lastMessageId}`;
          }
          this.isFirstLoad = false;
          this.isScrolling = false;
        }
      });
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getHours().toString().padStart(2, "0")}:${now
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    },
    updateLastMessage(content) {
      if (
        this.lastMessageIndex >= 0 &&
        this.lastMessageIndex < this.chatList.length
      ) {
        this.chatList[this.lastMessageIndex].content = content;
        if (!this.isManualScroll) {
          this.scrollToBottom();
        }
      }
    },
    checkNeedCreateActivity(message) {
      if (
        message.includes("是否需要根据以上信息创建") ||
        message.includes("是否需要根据当前信息")
      ) {
        this.showConfirmBtn = true;
        this.showConfirmBtnIndex = this.chatList.length - 1;
        this.isCreating = false;
      }
    },
    addQuickMessage(message) {
      console.log(message, "message");
      this.addMessage(message, true);
      this.socketTask.send(message);
      this.isManualScroll = false;
      this.isAutoScroll = true;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
      // this.socketTask.send({
      //     data: message.toString(),
      //     success: () => {
      //         this.isManualScroll = false;
      //         this.isAutoScroll = true;
      //         this.$nextTick(() => {
      //             this.scrollToBottom();
      //         });
      //     },
      //     fail: () => {
      //         alert('发送失败，请重试');
      //     }
      // });
    },
    createConfirmMessage() {
      const message = this.finalMessage;
      try {
        const timeMatch = message.match(
          /接龙时间[：:]\s*(.*?)\s*至\s*(.*?)(?=\n|$)/
        );
        const startTime = timeMatch?.[1]?.trim() || "";
        const endTime = timeMatch?.[2]?.trim() || "";
        const nameMatch = message.match(/接龙名称[：:]\s*(.*?)(?=\n|$)/m);
        const descMatch = message.match(/接龙描述[：:]\s*([\s\S]*?)(?=\n-|$)/m);
        const formItemsMatch = message.match(
          /报名填表项[：:]\s*([\s\S]*?)(?=\n\n|$)/
        );
        let formItems = "";
        if (formItemsMatch && formItemsMatch[1]) {
          const items = formItemsMatch[1]
            .split(/[,\n]|-/)
            .map((item) => item.trim())
            .filter((item) => item.length > 0)
            .filter((item) => !item.includes("姓名"));

          formItems = items.map((item) => `${item},`).join("");
          if (formItems.endsWith(",")) {
            formItems = formItems.substring(0, formItems.length - 1);
          }
        }

        const activityInfo = {
          activityName: nameMatch?.[1]?.trim() || "",
          description: descMatch?.[1]?.trim() || "",
          startTime,
          endTime,
          formItems,
          createTime: new Date().toISOString(),
        };

        localStorage.setItem("activityInfo", JSON.stringify(activityInfo));

        if (activityInfo.activityName.includes("打卡")) {
          // window.location.href = `/pages-mine/solitaire/solitaire?itm=2&selectType=add&isType=109&isAi=1`;
          const routeData = this.$router.resolve({
            path: "/solitaire",
            query: {
              activityId: 2,
              selectType: "add",
              isType: 109,
              isAi: 1,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          // window.location.href = `/pages-mine/solitaire/solitaire?itm=2&selectType=add&isType=106&isAi=1`;
          const routeData = this.$router.resolve({
            path: "/solitaire",
            query: {
              activityId: 2,
              selectType: "add",
              isType: 106,
              isAi: 1,
            },
          });
          window.open(routeData.href, "_blank");
        }
      } catch (error) {
        console.error("提取活动信息失败：", error);
      }
    },
    CopyText() {
      navigator.clipboard
        .writeText(this.finalMessage)
        .then(() => {
          alert("复制成功");
        })
        .catch(() => {
          alert("复制失败");
        });
    },
    RegenerateMessage() {
      this.socketTask.send(
        "我想重新生成一版，名称不要包含版本就正常的名字就行，你可以重新生成一份吗？"
      );
    },
    async _loginFun() {
      if (!localStorage.getItem("token")) {
        try {
          const response = await fetch("/api/login", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: "web_login_code",
            }),
          });
          const userInfo = await response.json();

          if (userInfo.status == 1) {
            localStorage.setItem("token", userInfo.data.token);
            localStorage.setItem("name", userInfo.data.userInfo.nickname);
            localStorage.setItem("imgSrc", userInfo.data.userInfo.profilePhoto);
            localStorage.setItem("unionId", userInfo.data.userInfo.unionId);
            localStorage.setItem("userPhone", userInfo.data.userInfo.phone);
            localStorage.setItem("openid", userInfo.data.userInfo.openidId);
            this.myTx = userInfo.data.userInfo.profilePhoto;
          }
        } catch (error) {
          console.error("登录失败:", error);
        }
      }
    },
    startScrollPolling() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }

      this.lastMessageLength = this.streamingMessage.length;

      this.scrollTimer = setInterval(() => {
        if (this.streamingMessage.length === this.lastMessageLength) {
          this.stopScrollPolling();
          return;
        }

        this.lastMessageLength = this.streamingMessage.length;

        if (!this.isManualScroll) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      }, 50);
    },
    stopScrollPolling() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    resetScrollState() {
      this.isManualScroll = false;
      this.isAutoScroll = true;
      this.scrollToBottom();
    },
  },
};
</script>

<style lang="scss" scoped>
.outBox {
  width: 100%;
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: stretch;
  /*background-color: #fff;*/
}
.box-1 {
  width: 100%;
  height: 0;
  flex: 1 0 auto;
  box-sizing: border-box;
  padding: 10px;
}
.chat-messages {
  height: 100%;
  scroll-behavior: smooth;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // 添加以下样式确保滚动正常工作
  position: relative;
  display: flex;
  flex-direction: column;
}
#msglist {
  flex: 1;
  overflow-y: auto;
  height: 100%;
  padding-bottom: 20px;
}
.chat-main {
  box-sizing: border-box;
  padding: 10px;
}
.chat-left-box {
  margin-bottom: 20px;
}
.tx-left {
  margin-right: 10px;
}
.tx {
  img {
    height: 40px;
    width: 40px;
    border-radius: 10px;
  }
}
.user-name {
  font-size: 14px;
  color: #3c4252;
  margin-bottom: 10px;
}
.content-box-left {
  width: 520px;
  background-color: white;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 0px 10px 10px 10px;
}
.content-box-right {
  background-color: #1877ff;
  color: white;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 10px 0px 10px 10px;
  word-break: break-all;
  max-width: 520px;
}
.chat-content-right {
  margin-right: 10px;
}
.chat-right-box {
  margin-bottom: 20px;
}
.content-txt {
  font-size: 15px;
  text-align: left;
  color: #3c4252;
  line-height: 21px;
  word-break: break-all;
  white-space: break-spaces;
}
.c-btns-item {
  padding: 5px;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  margin-right: 10px;
  span {
    font-size: 12px;
    color: #3c4252;
  }
  img {
    width: 13px;
    height: 13px;
    margin-right: 5px;
  }
}
.build-btn {
  margin-top: 10px;
  color: white;
  background-color: #1877ff;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  border-radius: 5px;
}
.input-container {
  background: #fff;
  padding: 10px;
  border-top: 1px solid #eee;
}
.input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
}
.voice-btn {
  width: 40px;
  font-size: 12px;
  padding: 0;
  background: none;
}
.text-input {
  flex: 1;
  height: 36px;
  background: #f7f7f7;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 14px;
}
.send-btn {
  width: 60px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: #1989fa;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
}
.record-box {
  flex: 1;
}
.record-btn {
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: #f7f7f7;
  border-radius: 4px;
  font-size: 14px;
}
.audio-player {
  display: flex;
  align-items: center;
  min-width: 60px;
  max-width: 140px;
  border-radius: 4px;
  transition: all 0.3s ease;
  background: #1877ff;
  .audio-duration {
    margin-left: 5px;
    color: #fff;
    font-size: 14px;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  text {
    font-size: 12px;
    color: #666;
  }
}
.audio-content {
  margin-left: 5px;
}
.pulse-animation-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  z-index: 10;
  pointer-events: none;
}
.pulse-animation {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pulse-circle {
  position: absolute;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  animation: pulse 2s infinite ease-out;
}
.pulse-circle-1 {
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}
.pulse-circle-2 {
  width: 75px;
  height: 75px;
  animation-delay: 0.7s;
}
.pulse-circle-3 {
  width: 100px;
  height: 100px;
  animation-delay: 1.4s;
}
.cancel-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 425px;
  background-color: transparent;
  z-index: 10;
  pointer-events: none;
}
.animation-box {
  width: 195px;
  height: 72px;
  border-radius: 10px;
  background: #1877ff;
  position: absolute;
  top: 63px;
  left: 50%;
  margin-left: -97.5px;
}
.sanjiao {
  width: 12.5px;
  height: 12.5px;
  position: absolute;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  bottom: -6px;
  left: 50%;
  margin-left: -7px;
}
.bg-red {
  background: #f73b42;
}
.bg-blue {
  background: #1877ff;
}
.cancel-btn2 {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 160px;
  left: 50%;
  margin-left: -30px;
}
.cancel-box .qxBtn {
  font-size: 13px;
  color: #a3a7ad;
  text-align: center;
  position: absolute;
  top: 233px;
  width: 100%;
}

/* 声波动画样式 */
.voice-wave-animation {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 2px;
  box-sizing: border-box;
}
.wave-bar {
  width: 2px;
  height: 15px;
  background-color: rgba(255, 255, 255, 0.8);
  margin: 0 2.5px;
  border-radius: 1.5px;
  animation: wave 1s infinite ease-in-out;
}

.wave-bar:nth-child(1) {
  animation-delay: 0.1s;
}

.wave-bar:nth-child(2) {
  animation-delay: 0.2s;
}

.wave-bar:nth-child(3) {
  animation-delay: 0.3s;
}

.wave-bar:nth-child(4) {
  animation-delay: 0.4s;
}

.wave-bar:nth-child(5) {
  animation-delay: 0.5s;
}

.wave-bar:nth-child(6) {
  animation-delay: 0.6s;
}

.wave-bar:nth-child(7) {
  animation-delay: 0.7s;
}

.wave-bar:nth-child(8) {
  animation-delay: 0.8s;
}

.wave-bar:nth-child(9) {
  animation-delay: 0.9s;
}

.wave-bar:nth-child(10) {
  animation-delay: 1s;
}

.wave-bar:nth-child(11) {
  animation-delay: 1.1s;
}

.wave-bar:nth-child(12) {
  animation-delay: 1.2s;
}

.wave-bar:nth-child(13) {
  animation-delay: 1.3s;
}

.wave-bar:nth-child(14) {
  animation-delay: 1.4s;
}

.wave-bar:nth-child(15) {
  animation-delay: 1.5s;
}

.wave-bar:nth-child(16) {
  animation-delay: 1.6s;
}

.wave-bar:nth-child(17) {
  animation-delay: 1.7s;
}

.wave-bar:nth-child(18) {
  animation-delay: 1.8s;
}

.wave-bar:nth-child(19) {
  animation-delay: 1.9s;
}

.wave-bar:nth-child(20) {
  animation-delay: 2s;
}

.wave-bar:nth-child(21) {
  animation-delay: 2.1s;
}

.wave-bar:nth-child(22) {
  animation-delay: 2.2s;
}

.wave-bar:nth-child(23) {
  animation-delay: 2.3s;
}

.wave-bar:nth-child(24) {
  animation-delay: 2.4s;
}

.wave-bar:nth-child(25) {
  animation-delay: 2.5s;
}

.wave-bar:nth-child(26) {
  animation-delay: 2.6s;
}

.wave-bar:nth-child(27) {
  animation-delay: 2.7s;
}

.wave-bar:nth-child(28) {
  animation-delay: 2.8s;
}

@keyframes wave {
  0%,
  100% {
    height: 15px;
  }
  50% {
    height: 30px;
  }
}
/* flex布局 */
.flex-depart-left {
  display: flex;
  align-items: center;
}

.flex-depart-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-depart-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-depart-center-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-depart-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.flex-depart-right-top {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.flex-depart-left-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex-depart-left-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.each-item {
  color: #3c78ff;
  margin-bottom: 10px;
  cursor: pointer;
}
.eachOne-box {
  /*padding-top: 10px;*/
}
.aPoint {
  color: #3c78ff;
  margin-right: 5px;
  font-size: 12px;
}
.point-after .pa-txt {
  font-size: 14px;
  text-decoration: underline;
}
</style>
